import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { LanguageService } from '../global-services/language.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectionByPlatform implements Resolve<void> {
  constructor(
    private _router: Router,
    private _languageService: LanguageService
  ) {}

  resolve(): void {
    // Get the current language from the language service
    const currentLang = this._languageService.getCurrentLanguageCode();

    let tenant = localStorage.getItem('tenant');
    if (tenant) {
      this._router.navigate([`${currentLang}/admin-login/${tenant}`]);
    } else {
      this._router.navigate([`${currentLang}/no-tenant-fallback`]);
    }
  }
}
